// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-menu {
  flex-direction: column;
  height: 50px;
  font-size: .8em;
  display: flex;
}

.status-menu .status-menu__cell {
  line-height: 1.25;
}

.status-menu .status-menu__color {
  border: 1px solid #5f656f;
  border-radius: 5px;
  width: 10px;
  height: 10px;
  display: inline-block;
}

.status-menu .status-menu-link {
  color: #fff;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  display: flex;
}

.status-menu .status-menu-link:hover {
  background: #0000001a;
}

.status-menu .status-menu-link__border {
  flex-direction: column;
  flex: 1;
  display: flex;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/containers/App/Header/Status/styles/Status.css","webpack://./services/frontend/app/containers/App/Header/Status/styles/Status.css"],"names":[],"mappings":"AADA;ECEE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,OAAO;EACP,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,OAAO;EACP,aAAa;AACf","sourcesContent":[".status-menu {\n  display: flex;\n  flex-direction: column;\n  height: 50px;\n  font-size: 0.8em;\n}\n\n  .status-menu .status-menu__cell {\n  line-height: 1.25;\n}\n\n  .status-menu .status-menu__color {\n    height: 10px;\n    width: 10px;\n    border-radius: 5px;\n    display: inline-block;\n    border: 1px solid #5f656f;\n  }\n\n  .status-menu .status-menu-link {\n    color: #fff;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    flex: 1;\n  }\n\n  .status-menu .status-menu-link:hover {\n      background: rgba(0, 0, 0, 0.1);\n    }\n\n  .status-menu .status-menu-link__border {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n    }\n",".status-menu {\n  flex-direction: column;\n  height: 50px;\n  font-size: .8em;\n  display: flex;\n}\n\n.status-menu .status-menu__cell {\n  line-height: 1.25;\n}\n\n.status-menu .status-menu__color {\n  border: 1px solid #5f656f;\n  border-radius: 5px;\n  width: 10px;\n  height: 10px;\n  display: inline-block;\n}\n\n.status-menu .status-menu-link {\n  color: #fff;\n  flex-direction: column;\n  flex: 1;\n  justify-content: center;\n  display: flex;\n}\n\n.status-menu .status-menu-link:hover {\n  background: #0000001a;\n}\n\n.status-menu .status-menu-link__border {\n  flex-direction: column;\n  flex: 1;\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
